const FOOTER_RESERVED_HEIGHT = 22;
const FOOTER_TOP_Y_OFFSET = 16;
const FOOTER_TEXT_Y_OFFSET = 8.5;
const FOOTER_SIDE_MARGIN = 14;
const FOOTER_LOGO_HEIGHT = 6;
const FOOTER_LOGO_GAP = 2.5;
const FOOTER_TEXT = 'Made with Struxor';
const FOOTER_TEXT_COLOR = 130;
const FOOTER_LINE_COLOR = 228;

let cachedLogoPromise;

const getLogoUrl = () => `${process.env.PUBLIC_URL || ''}/struxor_small.png`;

const loadFooterLogo = () => {
  if (cachedLogoPromise) {
    return cachedLogoPromise;
  }

  cachedLogoPromise = new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;

      const context = canvas.getContext('2d');
      if (!context) {
        resolve(null);
        return;
      }

      context.drawImage(image, 0, 0);
      resolve({
        dataUrl: canvas.toDataURL('image/png'),
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    };

    image.onerror = () => resolve(null);
    image.src = getLogoUrl();
  });

  return cachedLogoPromise;
};

export const reservePdfFooterSpace = (doc, y, requiredHeight = 0, topMargin = 20) => {
  const pageHeight = doc.internal.pageSize.getHeight();

  if (y + requiredHeight <= pageHeight - FOOTER_RESERVED_HEIGHT) {
    return y;
  }

  doc.addPage();
  return topMargin;
};

export const addStruxorPdfFooter = async (doc) => {
  const logo = await loadFooterLogo();
  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const currentPage = doc.internal.getCurrentPageInfo().pageNumber;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);

  for (let pageNumber = 1; pageNumber <= pageCount; pageNumber += 1) {
    doc.setPage(pageNumber);

    const footerLineY = pageHeight - FOOTER_TOP_Y_OFFSET;
    const footerTextY = pageHeight - FOOTER_TEXT_Y_OFFSET;
    const textWidth = doc.getTextWidth(FOOTER_TEXT);
    const logoWidth = logo
      ? FOOTER_LOGO_HEIGHT * (logo.width / logo.height)
      : 0;
    const contentWidth = logo
      ? logoWidth + FOOTER_LOGO_GAP + textWidth
      : textWidth;
    const startX = (pageWidth - contentWidth) / 2;

    doc.setDrawColor(FOOTER_LINE_COLOR);
    doc.line(FOOTER_SIDE_MARGIN, footerLineY, pageWidth - FOOTER_SIDE_MARGIN, footerLineY);

    if (logo) {
      doc.addImage(logo.dataUrl, 'PNG', startX, footerTextY - FOOTER_LOGO_HEIGHT + 1, logoWidth, FOOTER_LOGO_HEIGHT);
    }

    doc.setTextColor(FOOTER_TEXT_COLOR);
    doc.text(FOOTER_TEXT, startX + (logo ? logoWidth + FOOTER_LOGO_GAP : 0), footerTextY);
  }

  doc.setTextColor(0);
  doc.setPage(currentPage);
};

export { FOOTER_RESERVED_HEIGHT };